import { NgModule } from '@angular/core';

// Imports
import { AppConfigModule } from './app-config.module';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// Components
import { AppComponent } from './app.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ModalComponent } from './helpers/modal/modal.component';
import { ModalAlternativeComponent } from './helpers/modalalternative/modal-alternative.component';
import { LoadingComponent } from './helpers/loading/loading.component';

// Providers
import { CanActiveViaAuthGuard } from './services/auth-guard.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';

// Material
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { UnsavedChangesComponent } from './helpers/unsaved-changes/unsaved-changes.component';
import { FormCompleteComponent } from './helpers/form-complete/form-complete.component';


@NgModule({ declarations: [
        AppComponent,
        FooterComponent,
        ModalComponent,
        ModalAlternativeComponent,
        LoadingComponent,
        UnsavedChangesComponent,
        FormCompleteComponent
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        AppConfigModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        ReactiveFormsModule,
        BrowserAnimationsModule], providers: [
        ModalComponent,
        LoadingComponent,
        CookieService,
        CanActiveViaAuthGuard,
        { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
